import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    AD_TO_USER_MAP,
    ADResultType,
    USER_ICON_MAP,
} from '@models';

import { of } from 'rxjs';
import {
    map,
    mergeAll,
    toArray,
} from 'rxjs/operators';

export interface IDomain {
    isDefault: boolean;
    name: string;
}

interface IUserGroup {
    type: ADResultType;
    domain: string;
    identityName: string;
    displayName: string;
}

export class DirectoryUrl {
    public static get getDomains() { return `/api/DirectoryService/GetDomains`; }
    public static get getDirectoryPermissions() { return `/api/DirectoryService/GetDirectoryPermissions`; }
    public static get searchForUsersAndGroups() { return `/api/DirectoryService/SearchForUsersAndGroups`; }
}

export enum SearchContext {
    'All',
    'Users',
    'Groups',
}

@Injectable({
    providedIn: 'root',
})
export class DirectoryService {
    constructor(
        private _http: HttpClient,
    ) { }

    public getDomains = () => this._http
        .get<IDomain[]>(DirectoryUrl.getDomains)

    public searchForUsersAndGroups = (domain: string, query: string, searchContext: SearchContext) => this._http
        .get<IUserGroup[]>(DirectoryUrl.searchForUsersAndGroups, {
            params: {
                domain,
                prefix: encodeURIComponent(query),
                searchContext: SearchContext[searchContext],
            },
        })

    public adSearchFactory(domain: string, query: string, searchContext = SearchContext.All) {
        if (!query || query.length < 2) {
            return of([]);
        }

        return this.searchForUsersAndGroups(domain, query, searchContext)
            .pipe(
                mergeAll(),
                map(result => {
                    const userType = AD_TO_USER_MAP[result.type];

                    return {
                        id: result.identityName,
                        text: result.displayName,
                        type: userType,
                        icon: USER_ICON_MAP[userType],
                    };
                }),
                toArray(),
                map(results => ({
                    total: results.length,
                    data: results,
                })),
            );
    }
}
